
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/text-messages",
      function () {
        return require("private-next-pages/android/local/text-messages/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/text-messages"])
      });
    }
  